/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dashboard': {
    width: 208.008,
    height: 200,
    viewBox: '0 0 1065 1024',
    data: '<defs/><path pid="0" d="M836.24 951.828c13.926 11.96 18.472 29.696 12.533 45.958-5.775 15.933-20.234 26.214-36.782 26.214h-559.8c-16.507 0-30.966-10.281-36.741-26.214-5.94-16.262-1.434-33.997 11.51-45.138l119.275-83.927v-73.77c0-7.454 5.94-13.475 13.312-13.475h345.907c7.332 0 13.271 6.021 13.271 13.476v73.81l117.514 83.066zM1064.59 67.38v592.814c0 37.151-29.819 67.38-66.478 67.38H66.888c-36.66 0-66.52-30.229-66.52-67.38V67.38C.369 30.23 30.229 0 66.889 0h931.225c36.66 0 66.478 30.228 66.478 67.38zM971.49 538.952c0-14.91-11.92-26.952-26.624-26.952h-824.77c-14.705 0-26.583 12.042-26.583 26.952 0 14.868 11.878 26.951 26.583 26.951h824.77c14.705 0 26.624-12.083 26.624-26.951z"/>'
  }
})
